import { render, staticRenderFns } from "./vue-dropzone.vue?vue&type=template&id=5841db14&"
import script from "./vue-dropzone.vue?vue&type=script&lang=js&"
export * from "./vue-dropzone.vue?vue&type=script&lang=js&"
import style0 from "./vue-dropzone.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../myvaultspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports